import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "56",
  height: "40",
  viewBox: "0 0 56 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "56",
      height: "40",
      rx: "8",
      fill: "#E5FDC9"
    }, null, -1),
    _createElementVNode("path", {
      d: "M9.2 27.416C9.568 27.4 9.872 27.352 10.112 27.272C10.368 27.192 10.56 27.008 10.688 26.72C10.832 26.432 10.904 25.968 10.904 25.328V16.136C10.904 15.704 10.912 15.288 10.928 14.888C10.96 14.488 10.984 14.184 11 13.976C10.744 13.992 10.424 14.008 10.04 14.024C9.656 14.024 9.376 14.032 9.2 14.048V12.2C10.336 12.184 11.472 12.176 12.608 12.176C13.744 12.176 14.88 12.168 16.016 12.152C17.424 12.136 18.648 12.32 19.688 12.704C20.744 13.088 21.552 13.68 22.112 14.48C22.688 15.28 22.96 16.32 22.928 17.6C22.912 18.24 22.76 18.872 22.472 19.496C22.184 20.104 21.76 20.664 21.2 21.176C20.64 21.672 19.936 22.08 19.088 22.4C18.24 22.72 17.248 22.896 16.112 22.928C15.76 22.944 15.448 22.952 15.176 22.952C14.92 22.952 14.656 22.944 14.384 22.928V25.04C14.384 25.488 14.376 25.912 14.36 26.312C14.344 26.712 14.32 27.016 14.288 27.224C14.464 27.208 14.688 27.2 14.96 27.2C15.232 27.184 15.496 27.176 15.752 27.176C16.024 27.16 16.216 27.152 16.328 27.152V29H9.2V27.416ZM14.384 21.128C14.56 21.144 14.736 21.16 14.912 21.176C15.088 21.192 15.272 21.2 15.464 21.2C16.344 21.2 17.056 21.056 17.6 20.768C18.16 20.464 18.568 20.032 18.824 19.472C19.08 18.896 19.208 18.2 19.208 17.384C19.208 16.584 19.096 15.944 18.872 15.464C18.664 14.984 18.392 14.632 18.056 14.408C17.72 14.168 17.368 14.016 17 13.952C16.632 13.872 16.296 13.832 15.992 13.832C15.656 13.832 15.368 13.872 15.128 13.952C14.888 14.032 14.704 14.208 14.576 14.48C14.448 14.752 14.384 15.168 14.384 15.728V21.128Z",
      fill: "#294C52"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "42",
      cy: "12",
      r: "6",
      fill: "#294C52"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "42",
      cy: "28",
      r: "6",
      fill: "#93FC94"
    }, null, -1)
  ])))
}
export default { render: render }